'use client';

import React, { useEffect } from 'react';
import { AuthProvider } from '@/context/AuthContext';
import { initializeDraftCleanup } from '@/lib/draftUtils';
import { AIProvider } from '@/context/AIContext';
import { ClientProvider } from '@/context/ClientContext';
import { ChatProvider } from '@/context/ChatContext';
import { RefreshProvider } from '@/context/RefreshContext';
import { CommandPaletteProvider } from '@/context/CommandPaletteContext';
import MainLayout from '@/components/layout/MainLayout';
import { ServiceWorkerRegistration } from '@/components/pwa/ServiceWorkerRegistration';
import { ThemeProvider } from '@/components/providers/ThemeProvider';
import { ToastProvider } from '@/components/ui/Toast';
import { NotificationsProvider } from '@/context/NotificationsContext';

export function Providers({ children }: { children: React.ReactNode }) {
  // Initialize draft cleanup on app startup
  useEffect(() => {
    initializeDraftCleanup();
  }, []);

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <RefreshProvider>
        <AuthProvider>
          <AIProvider>
            <ClientProvider>
              <ChatProvider>
                <CommandPaletteProvider>
                  <ToastProvider>
                    <NotificationsProvider>
                      <ServiceWorkerRegistration />
                      <MainLayout>
                        {children}
                      </MainLayout>
                    </NotificationsProvider>
                  </ToastProvider>
                </CommandPaletteProvider>
              </ChatProvider>
            </ClientProvider>
          </AIProvider>
        </AuthProvider>
      </RefreshProvider>
    </ThemeProvider>
  );
}
